/* Swiper Configuration */
const swiperTestemonials = new Swiper('.swiper.swiper-testemonials', {
    direction: "horizontal",
    pagination: {
        el: ".swiper-pagination",
    },
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },

    breakpoints: {
        650: {
            spaceBetween: 30,
            slidesPerView: 2
        },
        990: {
            spaceBetween: 30,
            slidesPerView: 3,
            enabled: false
        },
        1140: {
            spaceBetween: 60,
            slidesPerView: 3,
            enabled: false
        }
    }
})